module.exports = __webpack_public_path__ + "static/images/success.e5b60c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.png
// module id = 4AGf
// module chunks = 11